export const accessToken: string =
  import.meta.env.VITE_MAPBOX_ACCESS_TOKEN ||
  "pk.eyJ1IjoiY3VsdHVyYWxlY29sb2dpZXNvZm1lbW9yeSIsImEiOiJja3QzbmRuZDkwaWF1MnZwaWRyYzRuOWUzIn0.zPyzqlCTHIjQuQzBAakVYw";

export const siteUrl: string = window.location.href.includes("localhost")
  ? (import.meta.env.VITE_STRAPI_URL || "http://localhost:8000")
  : "https://www.strapi.culturalecologies.com";

export const vimeoUrl =
  "https://api.vimeo.com/users/ricardovelasco/videos?per_page=99&fields=pictures,uri";

interface SlickSettings {
  infinite: boolean;
  slidesToShow: number;
  slidesToScroll: number;
  dots: boolean;
  arrows: boolean;
  responsive: Array<{
    breakpoint: number;
    settings: {
      slidesToShow: number;
    };
  }>;
}

export const slickDot: SlickSettings = {
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 993,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

export const chapterNames: string[] = [
  "chapterOne",
  "chapterTwo",
  "chapterThree",
  "chapterFour",
  "chapterFive",
  "chapterSix",
  "chapterSeven",
  "chapterEight",
];

export const swiperDelay = 7000;
